/* ==========================================================
   Bedz King Theme v2.05.0
   Cart Version 1.0
   Release: 2026-07-14

   Legacy cart controls: Removed from this file
   Cart controller: theme-custom.min.js

   ----------------------------------------------------------
   Version History
   ----------------------------------------------------------
   v2.05.000  Initial Framework
   v2.05.001  Header Search
   v2.05.002  Header Menu
   v2.05.003  Menu Accordion
   v2.05.004  Footer Navigation
   v2.05.005  Product Tab Switcher
   v2.05.006  Sidebar Dropdowns
   v2.05.007  Homepage Promo Products
   v2.05.008  Mobile Collection Refine / Sort
   v2.05.009  Legacy Search Disabled
   v2.05.010  Legacy Menu Disabled
   v2.05.011  Legacy UI Cleanup
   v2.05.012  Cart controls moved to theme-custom.js
   v2.05.013  Cart Version 1.0 completed
   v2.05.014  Desktop search behavior corrected
   v2.05.015  Cart assets minified and activated
   v2.05.016  Theme initialization and structure cleanup

   ----------------------------------------------------------
   TODO
   ----------------------------------------------------------
   ✓ Equal Heights reviewed — remove from legacy file later
   ✓ afterResize reviewed — remove from legacy file later
   ✓ Expo Mobile Nav reviewed — remove from legacy file later
   ✓ Homepage Promo Products migrated
   ✓ Mobile Collection Refine / Sort migrated
   ✓ Legacy UI Cleanup completed
   ✓ Cart Page Controls moved to theme-custom.js
   ✓ Cart Version 1.0 completed and tested
   ✓ Express Checkout compatibility verified
   ✓ Product Page Controls regression completed
◐ Desktop thumbnail hover — pre-existing issue; post-release fix
□ Remove retired code from main.patch-lite.v02.js
□ Rename to main.js after legacy retirement
   ========================================================== */

(function ($) {

  'use strict';

  /* ==========================================================
     CONFIGURATION
  ========================================================== */

  const BEDZ_DEBUG = false;

  /* ==========================================================
     UTILITIES
  ========================================================== */

  // Future helper functions will live here.
/* ==========================================================
   HEADER
========================================================== */

function initBedzHeaderButtons() {
  $('.search-btn').off('click');
  $('.menu-btn').off('click');

  $(document)
    .off('click.bedzHeaderSearch')
    .on('click.bedzHeaderSearch', 'a.search-btn', function (event) {
      // Desktop already has its inline search field.
      // Only toggle the search panel on mobile.
      if (!window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var $trigger = $(this);
      var $searchContainer = $('#search-container');
      var $searchInput = $searchContainer
        .find('input[type="search"]')
        .first();
      var isOpening = $searchContainer.hasClass('hide');

      if (isOpening) {
        $searchContainer
          .removeClass('hide')
          .attr('aria-hidden', 'false');
        $trigger
          .addClass('_open')
          .attr('aria-expanded', 'true');

        window.requestAnimationFrame(function () {
          $searchInput.trigger('focus');
        });
      } else {
        if ($searchInput.is(':focus')) {
          $searchInput.trigger('blur');
        }

        $searchContainer
          .addClass('hide')
          .attr('aria-hidden', 'true');
        $trigger
          .removeClass('_open')
          .attr('aria-expanded', 'false')
          .trigger('focus');
      }
    });

  $(document)
    .off('click.bedzHeaderMenu')
    .on('click.bedzHeaderMenu', 'a.menu-btn', function (event) {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var $trigger = $(this);
      var $menuContainer = $('#menu-container');
      var isOpening = $menuContainer.hasClass('hide');

      $menuContainer
        .toggleClass('hide', !isOpening)
        .attr('aria-hidden', isOpening ? 'false' : 'true');

      $trigger
        .toggleClass('_open', isOpening)
        .attr('aria-expanded', isOpening ? 'true' : 'false');

      if (!isOpening) {
        $trigger.trigger('focus');
      }
    });
}

  /* ==========================================================
     NAVIGATION
  ========================================================== */

  function initBedzSidebarDropdowns() {

    $('.sidebar .section-header').off('click');
    $('.sidebar-module .section-header').off('click');

        $(document)
      .off('click.bedzSidebarDropdowns')
      .on(
        'click.bedzSidebarDropdowns',
        '.sidebar .section-header, .sidebar-module .section-header',
        function (event) {

          // Do not affect mobile menu accordions
          if ($(this).closest('#menu-container, #menu-container-tablet').length) {
            return;
          }

          event.preventDefault();

          $(this).toggleClass('_open');

          $(this)
            .next('.sidebar-module__list, ul')
            .toggleClass('hide');

        }
      );
  }

  /* ==========================================================
     PRODUCT PAGES
  ========================================================== */

  function initBedzProductGallery() {

    if (!$('body.template-product').length) {
      return;
    }

    var slideCount = $('.swiper-container .swiper-slide').length;

    if (slideCount <= 1) {
      $('.swiper-button-prev, .swiper-button-next').addClass('hide');
      return;
    }

    if (typeof window.Swiper === 'undefined') {
      if (BEDZ_DEBUG) {
        console.warn('Bedz product gallery: Swiper is unavailable.');
      }

      return;
    }

    window.mySwiper = new window.Swiper('.swiper-container', {
      direction: 'horizontal',
      autoplay: 5000,
      loop: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      pagination: '.swiper-pagination'
    });

    window.mySwiper.on('onSlideChangeEnd', function (swiper) {
      var activeSlide = swiper.slides[swiper.activeIndex];

      if (
        activeSlide &&
        typeof window.variant_fix === 'function'
      ) {
        window.variant_fix.call(activeSlide);
      }
    });

  }

  function initBedzProductQuantityControls() {

    if (!$('body.template-product').length) {
      return;
    }

    $('body.template-product .fa-minus').off('click');
    $('body.template-product .fa-plus').off('click');

    $(document)
      .off('click.bedzProductQtyMinus')
      .on(
        'click.bedzProductQtyMinus',
        'body.template-product .fa-minus',
        function (event) {
          event.preventDefault();

          var quantityInput = $(event.currentTarget)
            .closest('.table')
            .find('input')
            .first();

          var quantity = parseInt(quantityInput.val(), 10) || 1;

          if (quantity > 1) {
            quantityInput.val(quantity - 1);

            if (typeof quantityInput.attr('onkeyup') !== 'undefined') {
              quantityInput.trigger('onkeyup');
            }
          }
        }
      );

    $(document)
      .off('click.bedzProductQtyPlus')
      .on(
        'click.bedzProductQtyPlus',
        'body.template-product .fa-plus',
        function (event) {
          event.preventDefault();

          var quantityInput = $(event.currentTarget)
            .closest('.table')
            .find('input')
            .first();

          var quantity = parseInt(quantityInput.val(), 10) || 0;

          quantityInput.val(quantity + 1);

          if (typeof quantityInput.attr('onkeyup') !== 'undefined') {
            quantityInput.trigger('onkeyup');
          }
        }
      );

  }

function initBedzMattressAddToCart() {

  if (!$('body.template-product').length) {
    return;
  }

  // Remove the legacy direct mattress add handlers.
  $('body.template-product ._mattress-module .add-btn').off('click');

  $(document)
    .off('click.bedzMattressAddToCart')
    .on(
      'click.bedzMattressAddToCart',
      'body.template-product ._mattress-module .add-btn',
      function (event) {
        event.preventDefault();

        var button = $(event.currentTarget);

        if (!button.hasClass('add-one')) {
          return false;
        }

        var mattressItem = button.closest('._mattress-item');
        var variantId = mattressItem.attr('data-variant-id');

        var quantity = parseInt(
          button.closest('.table').find('input').first().val(),
          10
        ) || 1;

        if (!variantId) {
          if (BEDZ_DEBUG) {
            console.error('Bedz mattress add-to-cart: variant ID missing.');
          }

          return false;
        }

        // Prevent accidental double submissions.
        if (button.hasClass('is-submitting')) {
          return false;
        }

        button
          .addClass('is-submitting')
          .attr('aria-disabled', 'true');

        var form = $('<form>', {
          method: 'post',
          action: '/cart/add'
        });

        form.append(
          $('<input>', {
            type: 'hidden',
            name: 'id',
            value: variantId
          })
        );

        form.append(
          $('<input>', {
            type: 'hidden',
            name: 'quantity',
            value: quantity
          })
        );

        form.append(
          $('<input>', {
            type: 'hidden',
            name: 'return_to',
            value: '/cart'
          })
        );

        $('body').append(form);

        // Native submission ensures Shopify updates the cart
        // before the cart page is displayed.
        form[0].submit();

        return false;
      }
    );

}

  function initBedzProductMobileTabs() {

    if (!$('body.template-product').length) {
      return;
    }

    $('body.template-product .mobile-tab').off('click');

    $(document)
      .off('click.bedzProductMobileTabs')
      .on(
        'click.bedzProductMobileTabs',
        'body.template-product .mobile-tab',
        function (event) {
          event.preventDefault();

          var tab = $(event.currentTarget);

          tab.next('div').toggleClass('hide');
          tab.toggleClass('active');

          setTimeout(function () {
            window.scroll(0, tab.offset().top);
          }, 100);

          return false;
        }
      );

  }

  function initBedzTabSwitcher() {

    $('.tabs a').off('click');
    $('.tab-link').off('click');

    $(document)
      .off('click.bedzTabs')
      .on('click.bedzTabs', '.tabs a, .tab-link', function (event) {

        var target = $(this).attr('href');

        if (!target || target.charAt(0) !== '#') {
          return;
        }

        event.preventDefault();

        $('.tabs a, .tab-link')
          .removeClass('_active active');

        $(this)
          .addClass('_active active');

        $('.tab-content, .tab-pane')
          .addClass('hide')
          .removeClass('active');

        $(target)
          .removeClass('hide')
          .addClass('active');

      });

  }
  /* ==========================================================
     COLLECTION PAGES
  ========================================================== */

  function initBedzMobileCollectionRefineSort() {

    $('#mobile-refine-sort-btns > div').off('click');

    $(document)
      .off('click.bedzMobileRefineSort')
      .on('click.bedzMobileRefineSort', '#mobile-refine-sort-btns > div', function (event) {

        var button = $(event.currentTarget);
        var buttonId = event.currentTarget.id;

        if (button.hasClass('_open')) {

          button.removeClass('_open');

          $('#isp_container ul[data-btn-id="' + buttonId + '"]')
            .removeClass('_open');

        } else {

          $('#mobile-refine-sort-btns > div')
            .not(event.currentTarget)
            .removeClass('_open');

          button.addClass('_open');

          $('#isp_container ul[data-btn-id!="' + buttonId + '"]')
            .removeClass('_open');

          $('#isp_container ul[data-btn-id="' + buttonId + '"]')
            .addClass('_open');

        }

      });

  }

  /* ==========================================================
     HOMEPAGE
  ========================================================== */

  function initBedzHomepagePromoProducts() {

    var hiddenSaleItems = $('#_sale-items ul.products > li.hide');

    if (!hiddenSaleItems.length) {
      return;
    }

    var indexes = [];

    for (var i = 0; i < hiddenSaleItems.length; i++) {
      indexes.push(i);
    }

    indexes = indexes.sort(function () {
      return 0.5 - Math.random();
    });

    indexes = indexes.slice(0, 6);

    for (var j = 0; j < hiddenSaleItems.length; j++) {
      if (indexes.indexOf(j) !== -1) {
        $(hiddenSaleItems[j]).removeClass('hide');
      }
    }
  }
    /* ==========================================================
     FOOTER
  ========================================================== */

  function initBedzFooterNavCollapse() {

    $('.footer-nav h4').off('click');
    $('.footer-nav-title').off('click');

    $(document)
      .off('click.bedzFooterNav')
      .on(
        'click.bedzFooterNav',
        '.footer-nav h4, .footer-nav-title',
        function (event) {

          event.preventDefault();

          $(this).toggleClass('_open');

          $(this)
            .next('ul, .footer-nav-list')
            .toggleClass('hide');

        }
      );

  }
  /* ==========================================================
     INITIALIZATION
  ========================================================== */
function initBedzThemeV205() {
  // HEADER
  initBedzHeaderButtons();

  // NAVIGATION
  initBedzSidebarDropdowns();

  // PRODUCT PAGES
initBedzProductGallery();
initBedzProductMobileTabs();
initBedzProductQuantityControls();
initBedzMattressAddToCart();
initBedzTabSwitcher();

  // HOMEPAGE
  initBedzHomepagePromoProducts();

  // COLLECTION PAGES
  initBedzMobileCollectionRefineSort();

  // FOOTER
  initBedzFooterNavCollapse();

  if (BEDZ_DEBUG) {
    console.log('Bedz King Theme v2.05.016 loaded');
  }
}

  $(function () {
    initBedzThemeV205();
  });

})(jQuery);